export const loadEnv = (): ViteEnv => {
  return import.meta.env;
};
